import { render } from "./ExportProductsModal.vue?vue&type=template&id=0af0c578"
import script from "./ExportProductsModal.vue?vue&type=script&lang=js"
export * from "./ExportProductsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__